<script setup lang="ts">
import { icon } from "@formkit/inputs";
import {
  DocumentTextIcon,
  ListBulletIcon,
  UsersIcon,
} from "@heroicons/vue/24/outline";
import { ref, onMounted, computed } from "vue";
import UsersTab from "@/components/UserManage.vue";
import ValidParcelNumbersTab from "@/components/RangeManage.vue";
import ClosureReasonsTab from "@/components/ReasonManage.vue";

type TabType = "user" | "consignment_range" | "manage_reason";

const activeTab = ref<TabType>("user");

const tabs = [
  { id: "user" as TabType, label: "Users", icon: UsersIcon },
  {
    id: "consignment_range" as TabType,
    label: "Valid Parcel Numbers",
    icon: ListBulletIcon,
  },
  {
    id: "manage_reason" as TabType,
    label: "Closure Reasons",
    icon: DocumentTextIcon,
  },
];
const tabComponentMap: Record<TabType, any> = {
  user: UsersTab,
  consignment_range: ValidParcelNumbersTab,
  manage_reason: ClosureReasonsTab,
};

const activeComponent = computed(() => tabComponentMap[activeTab.value]);

const changeTab = async (tab: TabType) => {
  activeTab.value = tab;
};
</script>
<template>
  <div>
    <div class="mb-6">
      <h1 class="text-2xl font-bold text-gray-900">Settings</h1>
    </div>
    <div class="rounded-xl border border-gray-200 bg-white">
      <div class="border-b border-gray-200">
        <div class="flex flex-wrap gap-5 p-4">
          <button
            v-for="tab in tabs"
            :key="tab.id"
            @click="changeTab(tab.id)"
            :class="[
              'flex gap-2 rounded-lg px-4 py-2 text-sm font-medium transition-colors',
              activeTab === tab.id
                ? 'bg-ram-red text-white'
                : 'bg-gray-100 text-gray-600 hover:bg-gray-200',
            ]"
          >
            <component :is="tab.icon" class="h-5 w-5" />
            {{ tab.label }}
          </button>
        </div>
      </div>
    </div>
    <div class="mt-4">
      <component :is="activeComponent" />
    </div>
  </div>
</template>
